<div class="run-dialog" [attr.data-testid]="texts.dialogTestId">
  <header class="run-dialog__header">
    <h2 mat-dialog-title class="run-dialog__title">{{ texts.title | translate }}</h2>
    <p class="run-dialog__subtitle">
      @if (data.subject.key) {
        <code class="run-dialog__key" data-testid="run-subject-key">{{ data.subject.key }}</code>
      }
      {{ data.subject.title }}
    </p>
  </header>

  <mat-dialog-content class="run-dialog__content">
    <div class="run-dialog__trial" role="note" data-testid="tf-probelauf-hinweis">
      <span class="run-dialog__trial-badge">{{ 'testCases.runDialog.trialBadge' | translate }}</span>
      <span class="run-dialog__trial-text" [innerHTML]="texts.trialHint | translate"></span>
    </div>

    @if (data.hasUnsavedChanges) {
      <p class="run-dialog__unsaved" role="note" data-testid="run-unsaved-hint">
        {{ 'testCases.runDialog.unsavedHint' | translate }}
      </p>
    }

    <div class="run-dialog__section">
      <span class="run-dialog__section-label" [id]="modeLabelId">
        {{ 'testCases.runDialog.modeLabel' | translate }}
      </span>
      <div class="run-dialog__options" role="radiogroup" [attr.aria-labelledby]="modeLabelId">
        <button
          #runOption
          type="button"
          role="radio"
          class="run-option"
          [class.run-option--selected]="selected() === 'MANUAL'"
          [attr.aria-checked]="selected() === 'MANUAL'"
          [attr.tabindex]="selected() === 'MANUAL' ? 0 : -1"
          [disabled]="starting()"
          data-testid="run-mode-manual"
          (keydown)="onOptionKeydown($event)"
          (click)="select('MANUAL')"
        >
          <span class="run-option__head">
            <span class="run-option__radio" aria-hidden="true"></span>
            <mat-icon class="run-option__icon" aria-hidden="true">manage_accounts</mat-icon>
            <span class="run-option__label">{{ 'testCases.runDialog.manual.label' | translate }}</span>
          </span>
          <span class="run-option__hint">{{ 'testCases.runDialog.manual.hint' | translate }}</span>
        </button>

        <button
          #runOption
          type="button"
          role="radio"
          class="run-option"
          [class.run-option--selected]="selected() === 'LOCAL_AUTOMATED'"
          [class.run-option--disabled]="!localAvailable()"
          [attr.aria-checked]="selected() === 'LOCAL_AUTOMATED'"
          [attr.tabindex]="selected() === 'LOCAL_AUTOMATED' ? 0 : -1"
          [disabled]="!localAvailable() || starting()"
          data-testid="run-mode-local"
          (keydown)="onOptionKeydown($event)"
          (click)="select('LOCAL_AUTOMATED')"
        >
          <span class="run-option__head">
            <span class="run-option__radio" aria-hidden="true"></span>
            <mat-icon class="run-option__icon" aria-hidden="true">settings</mat-icon>
            <span class="run-option__label">{{ 'testCases.runDialog.automated.label' | translate }}</span>
          </span>
          <span class="run-option__hint">
            @if (isModule) {
              {{ 'testCases.runDialog.automated.hint' | translate }}
            } @else if (stepCountFailed()) {
              {{ 'testCases.run.local.stepsCheckFailed' | translate }}
            } @else if (stepCount() === null) {
              {{ 'testCases.run.local.checkingSteps' | translate }}
            } @else if (localAvailable()) {
              {{ 'testCases.runDialog.automated.hint' | translate }}
            } @else {
              {{ 'testCases.run.local.noSteps' | translate }}
            }
          </span>
        </button>
      </div>
    </div>

    @if (isModule) {
      <app-run-parameters-section
        [projectId]="data.projectId"
        [moduleId]="data.subject.id"
        [mode]="selected() === 'MANUAL' ? 'MANUAL' : 'AUTOMATED'"
      />
    }

    <div class="run-dialog__automated" [hidden]="selected() !== 'LOCAL_AUTOMATED'">
      <app-runner-radio-list
        [projectId]="data.projectId"
        [selectWhenOnline]="connectedRunner()"
        (targetChange)="target.set($event)"
        (availabilityChange)="onAvailability($event)"
      />
      @if (selected() === 'LOCAL_AUTOMATED') {
        @if (helpClosable()) {
          <button
            #connectToggle
            type="button"
            class="run-dialog__connect-toggle"
            data-testid="runner-connect-toggle"
            [attr.aria-expanded]="helpOpen()"
            [attr.aria-controls]="helpOpen() ? connectHelpId : null"
            (click)="toggleHelp()"
          >
            <span aria-hidden="true">＋</span>
            {{ 'testCases.runDialog.connectToggle' | translate }}
          </button>
        }
        @if (helpOpen()) {
          <app-runner-connect-help
            class="run-dialog__connect-help"
            [attr.id]="connectHelpId"
            [projectId]="data.projectId"
            [closable]="helpClosable()"
            (connected)="onConnected($event)"
            (closed)="closeHelp()"
          />
        }
      }
    </div>
  </mat-dialog-content>

  @if (startError(); as error) {
    <p class="run-dialog__error" role="alert" [attr.data-testid]="texts.errorTestId">
      @if ('text' in error) {
        {{ error.text }}
      } @else {
        {{ error.key | translate: error.params }}
      }
    </p>
  }

  <mat-dialog-actions class="run-dialog__actions">
    <button mat-stroked-button type="button" data-testid="run-cancel" [disabled]="starting()" (click)="cancel()">
      {{ 'common.cancel' | translate }}
    </button>
    <button
      mat-flat-button
      type="button"
      class="run-dialog__start"
      [attr.data-testid]="texts.startTestId"
      [disabled]="startDisabled()"
      (click)="start()"
    >
      @if (starting()) {
        <mat-progress-spinner diameter="16" mode="indeterminate" aria-hidden="true" />
      } @else {
        <mat-icon aria-hidden="true">play_arrow</mat-icon>
      }
      {{ (starting() ? 'testCases.runDialog.starting' : 'testCases.runDialog.start') | translate }}
    </button>
  </mat-dialog-actions>
</div>
